module.exports = __webpack_public_path__ + "static/img/lahrs-kaiden.5c0739c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lahrs-kaiden.jpg
// module id = ISBa
// module chunks = 0